"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoredRatingsTableSchema = exports.StoredRatingRowSchema = exports.BoundOverrideSchema = exports.BoundOverrideChangeSchema = exports.BoundOverrideRemoveSchema = exports.BoundOverrideAddSchema = exports.RatingsFormSignalGroupSchema = exports.RatingsRelativeReferenceSchema = exports.RatingsRelativeMappingReferenceSchema = exports.RatingsRelativeSignalReferenceSchema = exports.RatingsRelativeSignalPairSchema = exports.BoundSlotSchema = exports.MAX_ROW_BARE_SIGNALS = exports.RATINGS_TABLE_FORM_VERSION = void 0;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const z = require("zod");
const ExpressionExpansion_1 = require("../ExpressionExpansion");
exports.RATINGS_TABLE_FORM_VERSION = 'normalized-ratings-form/v2';
exports.MAX_ROW_BARE_SIGNALS = 3;
exports.BoundSlotSchema = z.enum(['min', 'typ', 'max']);
exports.RatingsRelativeSignalPairSchema = z.object({
    targetId: z.string(),
    relativeId: z.string().nullable(),
});
exports.RatingsRelativeSignalReferenceSchema = z.object({
    kind: z.literal(ExpressionExpansion_1.RatingsRelativeReferenceKind.Signal),
    signalId: z.string().nullable(),
});
exports.RatingsRelativeMappingReferenceSchema = z.object({
    kind: z.literal(ExpressionExpansion_1.RatingsRelativeReferenceKind.Mapping),
    pairs: exports.RatingsRelativeSignalPairSchema.array(),
});
exports.RatingsRelativeReferenceSchema = z.discriminatedUnion('kind', [
    exports.RatingsRelativeSignalReferenceSchema,
    exports.RatingsRelativeMappingReferenceSchema,
]);
exports.RatingsFormSignalGroupSchema = z.object({
    id: z.string(),
    name: z.string(),
    signalIds: z.string().array(),
});
exports.BoundOverrideAddSchema = z.object({
    op: z.literal(ExpressionExpansion_1.BoundOverrideOp.Add),
    bound: sigma_engine_shared_1.ComponentBoundarySchema,
});
exports.BoundOverrideRemoveSchema = z.object({
    op: z.literal(ExpressionExpansion_1.BoundOverrideOp.Remove),
    id: z.string(),
});
exports.BoundOverrideChangeSchema = z.object({
    op: z.literal(ExpressionExpansion_1.BoundOverrideOp.Change),
    id: z.string(),
    slot: exports.BoundSlotSchema.optional(),
    value: z.number().optional(),
    relativeSignalId: z.string().nullable().optional(),
    signalIds: z.string().array().optional(),
    inclusive: z.boolean().optional(),
    level: sigma_engine_shared_1.BoundaryLevelSchema.optional(),
});
exports.BoundOverrideSchema = z.discriminatedUnion('op', [
    exports.BoundOverrideAddSchema,
    exports.BoundOverrideRemoveSchema,
    exports.BoundOverrideChangeSchema,
]);
exports.StoredRatingRowSchema = z.object({
    id: z.string(),
    origin: z.nativeEnum(ExpressionExpansion_1.RatingRowOrigin),
    characteristic: z.enum(sigma_engine_shared_1.RatedBoundaryCharacteristics),
    description: z.string(),
    min: z.string(),
    typ: z.string(),
    max: z.string(),
    relative: exports.RatingsRelativeReferenceSchema.nullable(),
    conditionIds: z.string().array(),
    groupIds: z.string().array(),
    signalIds: z.string().array().optional(),
    boundaryIds: z.string().array(),
    overrides: exports.BoundOverrideSchema.array(),
});
exports.StoredRatingsTableSchema = z.object({
    formVersion: z.literal(exports.RATINGS_TABLE_FORM_VERSION),
    kind: z.nativeEnum(ExpressionExpansion_1.RatingsKind),
    signalGroups: exports.RatingsFormSignalGroupSchema.array(),
    rows: exports.StoredRatingRowSchema.array(),
});
//# sourceMappingURL=stored-ratings-table.js.map